module.exports = __webpack_public_path__ + "media/icons/close-2a48a7e29ade66306ca7e23befc5eb61.svg";